import React from 'react';
import { Form } from 'react-bootstrap';

function SimpleCheck({ label, value, onChange, ...props }) {
  return (
    <Form.Group className="form-group">
      <Form.Label>{label}</Form.Label>
      <Form.Check
        checked={value}
        onChange={e => onChange(e.target.checked)}
        {...props}
      />
    </Form.Group>
  );
}

export default SimpleCheck;
